const t=t=>{const{className:i}=t;return{root:["bp-NativeList",i,{margin:0,padding:0,listStyle:"inherit",marginLeft:24}]}};export{t as getStyles};
//# sourceMappingURL=NativeList.styles.js.map
